module.exports = __webpack_public_path__ + "static/media/trash.c0af682b.svg";